export default "__VITE_ASSET__66bd2ac0__"